var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfspeellijst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "afspeellijst-a",
    x1: "0%",
    x2: "50%",
    y1: "3.533%",
    y2: "96.467%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FB8C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F55325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "afspeellijst-b",
    x1: "0%",
    x2: "50%",
    y1: ".82%",
    y2: "99.18%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FB8C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F55325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "afspeellijst-c",
    x1: "33.734%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FB8C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F55325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "afspeellijst-d",
    x1: "0%",
    x2: "50%",
    y1: "25.314%",
    y2: "74.686%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FB8C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F55325"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.7,
    transform: "rotate(-180 52.83 61)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#afspeellijst-a)",
    points: "0 30.499 0 80.619 49.23 93.809 97.31 45.719 90.96 22.009 52.83 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#afspeellijst-b)",
    points: "0 30.499 0 52.259 30.33 104.79 82.641 104.79 105.66 91.499 105.66 30.499 52.83 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#afspeellijst-c)",
    points: "0 91.499 13.17 99.099 37.53 74.739 28.47 40.929 0 33.299"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#afspeellijst-d)",
    points: "28.65 56.049 6.141 95.04 52.83 121.999 100 94.759 77.651 56.049"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.3371429,22.2377143 C44.2628571,21.6274286 45.4422857,21.5725714 46.416,22.0902857 C47.3965714,22.6182857 48.0034286,23.6331429 48.0000145,24.7405714 L48.0000145,24.7405714 L48.0000145,37.0011429 C48.0000145,39.7577143 45.7577143,42 43.0011429,42 C40.2411429,42 37.9988571,39.7577143 37.9988571,37.0011429 C37.9988571,34.2411429 40.2411429,31.9988571 43.0011429,31.9988571 L43.0011429,31.9988571 L46.0011429,31.9988571 L46.0011429,24.7371429 C46.0011429,24.3668571 45.7988571,24.0308571 45.4731429,23.8525714 C45.144,23.6777143 44.7497143,23.7017143 44.4445714,23.904 L44.4445714,23.904 L36.4457143,29.2354286 C36.168,29.424 36,29.736 36,30.072 L36,30.072 L36,43.0011429 C36,45.7577143 33.7577143,48 31.0011429,48 C28.2411429,48 25.9988571,45.7577143 25.9988571,43.0011429 C25.9988571,40.2411429 28.2411429,37.9988571 31.0011429,37.9988571 L31.0011429,37.9988571 L34.0011429,37.9988571 L34.0011429,30.072 C34.0011429,29.0674286 34.5017143,28.1314286 35.3382857,27.576 L35.3382857,27.576 Z M34.0011429,40.0011429 L31.0011429,40.0011429 C29.3485714,40.0011429 28.0011429,41.3485714 28.0011429,43.0011429 C28.0011429,44.6537143 29.3485714,46.0011429 31.0011429,46.0011429 C32.6537143,46.0011429 34.0011429,44.6537143 34.0011429,43.0011429 L34.0011429,43.0011429 L34.0011429,40.0011429 Z M46.0011429,34.0011429 L43.0011429,34.0011429 C41.3485714,34.0011429 40.0011429,35.3485714 40.0011429,37.0011429 C40.0011429,38.6537143 41.3485714,40.0011429 43.0011429,40.0011429 C44.6537143,40.0011429 46.0011429,38.6537143 46.0011429,37.0011429 L46.0011429,37.0011429 L46.0011429,34.0011429 Z M3,30 C4.65257143,30 6,31.3474286 6,33 C6,34.6525714 4.65257143,36 3,36 C1.34742857,36 -1.46168791e-13,34.6525714 -1.46168791e-13,33 C-1.46168791e-13,31.3474286 1.34742857,30 3,30 Z M28.9988571,31.9988571 L28.9988571,34.0011429 L10.9988571,34.0011429 L10.9988571,31.9988571 L28.9988571,31.9988571 Z M3,31.9988571 C2.45142857,31.9988571 1.99885714,32.4514286 1.99885714,33 C1.99885714,33.5485714 2.45142857,34.0011429 3,34.0011429 C3.552,34.0011429 4.00114286,33.5485714 4.00114286,33 C4.00114286,32.4514286 3.552,31.9988571 3,31.9988571 Z M3,19.9988571 C4.65257143,19.9988571 6,21.3462857 6,22.9988571 C6,24.6514286 4.65257143,25.9988571 3,25.9988571 C1.34742857,25.9988571 -1.46168791e-13,24.6514286 -1.46168791e-13,22.9988571 C-1.46168791e-13,21.3462857 1.34742857,19.9988571 3,19.9988571 Z M34.9988571,22.0011429 L34.9988571,24 L10.9988571,24 L10.9988571,22.0011429 L34.9988571,22.0011429 Z M3,22.0011429 C2.45142857,22.0011429 1.99885714,22.4502857 1.99885714,22.9988571 C1.99885714,23.5508571 2.45142857,24 3,24 C3.552,24 4.00114286,23.5508571 4.00114286,22.9988571 C4.00114286,22.4502857 3.552,22.0011429 3,22.0011429 Z M3,10.0011429 C4.65257143,10.0011429 6,11.3485714 6,13.0011429 C6,14.6537143 4.65257143,16.0011429 3,16.0011429 C1.34742857,16.0011429 -1.46168791e-13,14.6537143 -1.46168791e-13,13.0011429 C-1.46168791e-13,11.3485714 1.34742857,10.0011429 3,10.0011429 Z M37.0011429,12 L37.0011429,13.9988571 L10.9988571,13.9988571 L10.9988571,12 L37.0011429,12 Z M3,12 C2.45142857,12 1.99885714,12.4491429 1.99885714,13.0011429 C1.99885714,13.5497143 2.45142857,13.9988571 3,13.9988571 C3.552,13.9988571 4.00114286,13.5497143 4.00114286,13.0011429 C4.00114286,12.4491429 3.552,12 3,12 Z M3,3.89783444e-13 C4.65257143,3.89783444e-13 6,1.34742857 6,3 C6,4.65257143 4.65257143,6 3,6 C1.34742857,6 -1.46168791e-13,4.65257143 -1.46168791e-13,3 C-1.46168791e-13,1.34742857 1.34742857,3.89783444e-13 3,3.89783444e-13 Z M37.0011429,1.99885714 L37.0011429,4.00114286 L10.9988571,4.00114286 L10.9988571,1.99885714 L37.0011429,1.99885714 Z M3,1.99885714 C2.45142857,1.99885714 1.99885714,2.45142857 1.99885714,3 C1.99885714,3.54857143 2.45142857,4.00114286 3,4.00114286 C3.552,4.00114286 4.00114286,3.54857143 4.00114286,3 C4.00114286,2.45142857 3.552,1.99885714 3,1.99885714 Z",
    transform: "translate(34 42)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfspeellijst);
export default __webpack_public_path__ + "static/media/afspeellijst.83f77c5952383c25c3c814482a659067.svg";
export { ForwardRef as ReactComponent };